import type { Parameters } from 'proton-account/src/pages/interface';
import result from 'proton-account/src/pages/reset-password';

const data = (): Parameters => ({
    ...result(),
});

export default data;
